module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Line_Spacing"
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Dante MT Std'",
      "font-size": "2.50em"
    }
  }, [_vm._v("The Honeywood Settlement")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Dante MT Std'",
      "font-size": "1.75em"
    }
  }, [_vm._v("by H.B. Creswell")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image0.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf91d4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0001.vue
// module id = 60
// module chunks = 0